import * as React from "react";
const SvgFiRrSnowmobile = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-snowmobile_svg__a)">
      <path
        fill="#062147"
        d="M23 19a1 1 0 0 0-1 1 2 2 0 0 1-2 2h-.382l-1.213-2.427a7 7 0 0 0 3.295-2.5l1.524-2.133a3.986 3.986 0 0 0-.815-5.494l-6.8-5.234a1 1 0 0 0-1.22 1.584l.557.429A11.7 11.7 0 0 1 16 10.183 2.92 2.92 0 0 1 13.032 13H11a1 1 0 1 0 0 2h2.032A4.937 4.937 0 0 0 18 10.135a8 8 0 0 0-.216-1.729l3.405 2.621a1.993 1.993 0 0 1 .408 2.746l-1.524 2.133A5.01 5.01 0 0 1 16 18H8.07l.692-1.24a1.98 1.98 0 0 0 .145-1.546 1.94 1.94 0 0 0-.949-1.154l-3.4-2a1 1 0 0 1-.5-1.255l2.047-3.252a1.006 1.006 0 0 1 1.342-.447c.131.065.488.255.975.516l-1.77 2.9a1 1 0 1 0 1.705 1.043l1.828-2.99c1.142.617 2.395 1.3 3.26 1.768a1.001 1.001 0 0 0 .955-1.76c-.22-.12-5.415-2.944-6.059-3.266a2.98 2.98 0 0 0-2.29-.163 2.9 2.9 0 0 0-1.686 1.418L2.317 9.826A2.986 2.986 0 0 0 3.6 13.819L7.008 15.8 5.78 18H3.535l-1.7-2.555a1 1 0 1 0-1.664 1.11l1.261 1.891A3.012 3.012 0 0 0 3 24h6a3.015 3.015 0 0 0 2.828-4H16c.125 0 .25 0 .373-.01l1.01 2.01H15a1 1 0 1 0 0 2h5a4 4 0 0 0 4-4 1 1 0 0 0-1-1m-13 2a1 1 0 0 1-1 1H3a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1M8 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-snowmobile_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSnowmobile;
